module.exports = __webpack_public_path__ + "static/media/iride_pass_video_first_new.70681ae5.gif";